import { render, staticRenderFns } from "./plugins.vue?vue&type=template&id=6c32ce97&scoped=true&"
import script from "./plugins.vue?vue&type=script&lang=js&"
export * from "./plugins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c32ce97",
  null
  
)

export default component.exports